// extracted by mini-css-extract-plugin
export var aboutBodyContainer = "about-module--aboutBodyContainer--0fa2a";
export var aboutContainer = "about-module--aboutContainer--4d41a";
export var aboutContainersContainer = "about-module--aboutContainersContainer--12daa";
export var aboutContent = "about-module--aboutContent--4344d";
export var container = "about-module--container--dc795";